/* eslint-disable no-useless-escape */
/* eslint-disable no-else-return */
export function hasNumber(string) {
  return /\d/.test(string);
}

export function hasLowerCase(string) {
  return /[a-z]/.test(string);
}

export function hasUpperCase(string) {
  return /[A-Z]/.test(string);
}

export function hasSpecialCharacter(string) {
  return /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(string);
}

export function hasSpecialCharacterWhitespaceAllowed(string) {
  return /[`!@#$%^&*()+\=\[\]{};':"\\|,<>\/?~]/.test(string);
}

export function isValidEmail(string) {
  return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    string,
  );
}

export function emailHasSpecialCharacter(string) {
  let st = string.replace('@', '');
  st = string.replace('.', '');
  return /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(st);
}

export async function validateEmail(email) {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    );
}
